import React from 'react'

import { ListItemControlSDUI } from './ListItemControlSDUI'
import { ListItemSDUIRendererBase } from '../hooks/ListItemSDUIRendererBase'
import type { SDUIComponentProps } from '../interfaces'

interface ListItemControlSDUIRendererProps {
  sduiComponent: SDUIComponentProps
}

export const ListItemControlSDUIRenderer: React.FC<ListItemControlSDUIRendererProps> = ({
  sduiComponent,
}) => (
  <ListItemSDUIRendererBase
    sduiComponent={sduiComponent}
    inlineItems={(sduiComponent.props?.items ?? []) as ListItemControlData[]}
    Component={ListItemControlSDUI}
  />
)
